import {
  FETCH_DEVICES,
  FETCH_DEVICE,
  DELETE_DEVICE,
  UPDATE_DEVICE,
  CREATE_DEVICE,
  SET_DEVICE_FILTER,
} from './actionTypes'
import api from 'utils/api'

export const fetchDevices = (currentVenueId, config) => (dispatch) =>
  api.fetchDevices(currentVenueId, config).then(({ data }) => dispatch(fetchDevicesAction(data)))

export const fetchDevice = (currentVenueId, deviceId, config) => (dispatch) =>
  api
    .fetchDevice(currentVenueId, deviceId, config)
    .then(({ data }) => dispatch(fetchDeviceAction(data)))

export const deleteDevice = (currentVenueId, uuid, config) => (dispatch) =>
  api
    .deleteDevice(currentVenueId, uuid, config)
    .then(({ data }) => dispatch(deleteDeviceAction(data)))

export const updateDevice = (payload, config) => (dispatch) =>
  api.updateDevice(payload, config).then(({ data }) => dispatch(updateDeviceAction(data)))

export const bulkUpdateDevice = (payload, config) => (dispatch) =>
  api.bulkUpdateDevice(payload, config).then(({ data }) => dispatch(updateDeviceAction(data)))

export const createDevice = (currentVenueId, payload, config) => (dispatch) =>
  api
    .createDevice(currentVenueId, payload, config)
    .then(({ data }) => dispatch(createDeviceAction(data)))

export const fetchDevicesAction = (devices) => ({
  type: FETCH_DEVICES,
  payload: devices,
})

export const fetchDeviceAction = (device) => ({
  type: FETCH_DEVICE,
  payload: device,
})

export const deleteDeviceAction = (device) => ({
  type: DELETE_DEVICE,
  payload: device,
})

export const updateDeviceAction = (device) => ({
  type: UPDATE_DEVICE,
  payload: device,
})

export const createDeviceAction = (device) => ({
  type: CREATE_DEVICE,
  payload: device,
})

export const setDeviceFilter = (payload) => ({
  type: SET_DEVICE_FILTER,
  payload,
})
